// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { connect } from 'react-redux';
import { SearchResultList, ISearchResultsProps } from './searchResultList';
import { FilterList } from './filterList';
import { fetchResults, updateKeyword, updateFacet, initializeKeyword } from './actions/app-actions';
import { ISearchResultData } from './objects/iSearchResultData';
import { ISearchFacet } from './objects/iSearchFacet';
import { SearchBox } from './searchBox';
import 'url-search-params-polyfill';
import 'es6-promise-promise';
import find = require('lodash/find');
import { IAutocompleteResults, DefaultAutoCompleteResults } from './objects/autocomplete';
declare var dataLayer: any;

interface ISearchPageProps {
    dispatch: any,
    showSearchBar: boolean,
	isLoading: boolean,
	displayStart: number,
	displayLength: number,
	searchResultData: ISearchResultData,
    searchFacets: ISearchFacet[],
    currentCountry: string
}

interface ISearchPageState {
}

class SearchPage extends React.Component<ISearchPageProps, ISearchPageState> {
	componentWillMount() {
        let search = location.search;
        let params = new URLSearchParams(search);
        let keywordValue = params.get('q');
        let regex = new RegExp('^\/products\/by-market((\/\w+)+|\/?)$');
        this.props.dispatch(initializeKeyword([{ Text: keywordValue, Value: keywordValue }]));
        if (params.get('manufacturerid')) {
            this.props.dispatch(updateFacet('ManufacturerId', [{ Text: params.get('manufacturerid').replace(/-/g, ' '), Value: params.get('manufacturerid').replace(/-/g, ' ') }]));
        }
        if (params.get('manufacturer')) {
            this.props.dispatch(updateFacet('Manufacturer', [{ Text: params.get('manufacturer').replace(/-/g, ' '), Value: params.get('manufacturer').replace(/-/g, ' ') }]));
        }
        if (params.get('category') && regex.test(location.pathname)) {
            this.props.dispatch(updateFacet('EllsworthMarkets', [{ Text: params.get('category').replace(/-/g,' '), Value: params.get('category').replace(' ', '-') }]));
        }
        if (params.get('category') && !regex.test(location.pathname)) {
            this.props.dispatch(updateFacet('CatalogNodes', [{ Text: params.get('category').replace(/-/g, ' '), Value: params.get('category') }]));
        }
        if (params.get('brand')) {
            this.props.dispatch(updateFacet('Brand', [{ Text: params.get('brand'), Value: params.get('brand') }]));
        }
        if (params.get('applicatortype')) {
            this.props.dispatch(updateFacet('ApplicatorType', [{ Text: params.get('applicatortype'), Value: params.get('applicatortype') }]));
        }
        if (params.get('backingtype')) {
            this.props.dispatch(updateFacet('BackingType', [{ Text: params.get('backingtype'), Value: params.get('backingtype') }]));
        }
        if (params.get('cartridgecapacity')) {
            this.props.dispatch(updateFacet('CartridgeCapacity', [{ Text: params.get('cartridgecapacity'), Value: params.get('cartridgecapacity') }]));
        }
        if (params.get('colorfilter')) {
            this.props.dispatch(updateFacet('ColorFilter', [{ Text: params.get('colorfilter'), Value: params.get('colorfilter') }]));
        }
        if (params.get('componentsfilter')) {
            this.props.dispatch(updateFacet('ComponentsFilter', [{ Text: params.get('componentsfilter'), Value: params.get('componentsfilter') }]));
        }
        if (params.get('curesystem')) {
            this.props.dispatch(updateFacet('CureSystem', [{ Text: params.get('curesystem'), Value: params.get('curesystem') }]));
        }
        if (params.get('dispensingvalvetype')) {
            this.props.dispatch(updateFacet('DispensingValveType', [{ Text: params.get('dispensingvalvetype'), Value: params.get('dispensingvalvetype') }]));
        }
        if (params.get('elements')) {
            this.props.dispatch(updateFacet('Elements', [{ Text: params.get('elements'), Value: params.get('elements') }]));
        }
        if (params.get('feedpower')) {
            this.props.dispatch(updateFacet('FeedPower', [{ Text: params.get('feedpower'), Value: params.get('feedpower') }]));
        }
        if (params.get('hotmeltstickwidth')) {
            this.props.dispatch(updateFacet('HotMeltStickWidth', [{ Text: params.get('hotmeltstickwidth'), Value: params.get('hotmeltstickwidth') }]));
        }
        if (params.get('hotmelttype')) {
            this.props.dispatch(updateFacet('HotMeltType', [{ Text: params.get('hotmelttype'), Value: params.get('hotmelttype') }]));
        }
        if (params.get('insidediameter')) {
            this.props.dispatch(updateFacet('InsideDiameter', [{ Text: params.get('insidediameter'), Value: params.get('insidediameter') }]));
        }
        if (params.get('mixerlength')) {
            this.props.dispatch(updateFacet('MixerLength', [{ Text: params.get('mixerlength'), Value: params.get('mixerlength') }]));
        }
        if (params.get('polesortips')) {
            this.props.dispatch(updateFacet('PolesOrTips', [{ Text: params.get('polesortips'), Value: params.get('polesortips') }]));
        }
        if (params.get('profile')) {
            this.props.dispatch(updateFacet('Profile', [{ Text: params.get('profile'), Value: params.get('profile') }]));
        }
        if (params.get('releaseagenttype')) {
            this.props.dispatch(updateFacet('ReleaseAgentType', [{ Text: params.get('releaseagenttype'), Value: params.get('releaseagenttype') }]));
        }
        if (params.get('spray')) {
            this.props.dispatch(updateFacet('Spray', [{ Text: params.get('spray'), Value: params.get('spray') }]));
        }
        if (params.get('staticbagwidth')) {
            this.props.dispatch(updateFacet('StaticBagWidth', [{ Text: params.get('staticbagwidth'), Value: params.get('staticbagwidth') }]));
        }
        if (params.get('tack')) {
            this.props.dispatch(updateFacet('Tack', [{ Text: params.get('tack'), Value: params.get('tack') }]));
        }
        if (params.get('tapewidth')) {
            this.props.dispatch(updateFacet('TapeWidth', [{ Text: params.get('tapewidth'), Value: params.get('tapewidth') }]));
        }
        if (params.get('tapered')) {
            this.props.dispatch(updateFacet('Tapered', [{ Text: params.get('tapered'), Value: params.get('tapered') }]));
        }
        if (params.get('tipangle')) {
            this.props.dispatch(updateFacet('TipAngle', [{ Text: params.get('tipangle'), Value: params.get('tipangle') }]));
        }
        if (params.get('tipgauge')) {
            this.props.dispatch(updateFacet('TipGauge', [{ Text: params.get('tipgauge'), Value: params.get('tipgauge') }]));
        }
        if (params.get('tipmaterial')) {
            this.props.dispatch(updateFacet('TipMaterial', [{ Text: params.get('tipmaterial'), Value: params.get('tipmaterial') }]));
        }
        if (params.get('tiporcartridgetype')) {
            this.props.dispatch(updateFacet('TipOrCartridgeType', [{ Text: params.get('tiporcartridgetype'), Value: params.get('tiporcartridgetype') }]));
        }

		this._doSearch();
	}

	render() {
		let search = location.search;
        let params = new URLSearchParams(search);
        let path = location.pathname;
		return (
			<div className="search-app-container">
				<div className="sidebar-container">
                    {this.props.showSearchBar ?
                        <SearchBox
                            searchTerm={this._getSearchTerm()}
                            dispatch={this.props.dispatch}
                            onChange={this._doSearch.bind(this)}
                            suggestion={this.props.searchResultData.suggestion} />
                        : null}
                    <FilterList filters={this.props.searchResultData.facets} dispatch={this.props.dispatch} onChange={this._doSearch.bind(this)} searchFacets={this.props.searchFacets}/>
                </div>
                <SearchResultList path={path} query={this._getSearchTerm().Text} aaData={this.props.searchResultData.aaData} iTotalDisplayRecords={this.props.searchResultData.iTotalDisplayRecords} iDisplayLength={this.props.displayLength} iDisplayStart={this.props.displayStart} dispatch={this.props.dispatch} onChange={this._doSearch.bind(this)} isLoading={this.props.isLoading} currentCountry={this.props.currentCountry} />
                {this.props.isLoading ? "" : this._sendViewItemListEvent() }
            </div>
		);
	}

	_doSearch() {
        this.props.dispatch(fetchResults());//.then(() =>
		//	console.log(this.props.searchResultData)
		//);
    }

    _sendViewItemListEvent() {
        if (this.props.searchResultData.aaData.length > 0) {
            let eventData = [];
            this.props.searchResultData.aaData.forEach((data, i) => {
                if (data[3] != null && data[3] !== "") {
                    eventData.push({
                        item_number: data[2],
                        item_id: data[21],
                        item_name: data[0],
                        index: i,
                        item_brand: data[20],
                        item_subbrand: data[22],
                        price: parseFloat((data[3]).toString().replace(/\$/, '').replace(/,/, '').split(" ")[0].trim()),
                        quantity: 1
                    });
                } else {
                    eventData.push({
                        item_number: data[2],
                        item_id: data[21],
                        item_name: data[0],
                        index: i,
                        item_brand: data[20],
                        item_subbrand: data[22],
                    });
                }
            });
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    currency: this.props.currentCountry === 'USA' ? 'USD' : 'CAD',
                    items: eventData
                }
            });
        }
    }

	_getSearchTerm() {
		let keywordFacet = find(this.props.searchFacets, (facet) => facet.facet == 'Keyword');
		if (keywordFacet != undefined) {
			if (keywordFacet.search[0] != undefined)
				return keywordFacet.search[0];
			return { Text: "", Value: "" };
		}
		else {
			let search = location.search;
			let params = new URLSearchParams(search);
			return { Text: params.get('q'), Value: params.get('q') };
		}
    }
}

export default connect((state) => state)(SearchPage);
